import React, { useEffect, useState } from 'react';
import { OfflineBanner } from './OfflineBanner';
import { ServiceWorkerUpdateBanner } from './ServiceWorkerUpdateBanner';
import { subscribeSwUpdateAvailable } from '../pwa/swEvents';

/**
 * Shell-level PWA UX: offline notice + service worker update (non-blocking).
 * Pair with {@link InstallAppButton} in the header for install prompts.
 */
export const PwaShellBars: React.FC = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [dismissedUpdate, setDismissedUpdate] = useState(false);

  useEffect(() => {
    const unsub = subscribeSwUpdateAvailable(() => setUpdateAvailable(true));
    return unsub;
  }, []);

  return (
    <>
      <OfflineBanner />
      <ServiceWorkerUpdateBanner
        visible={updateAvailable && !dismissedUpdate}
        onDismiss={() => setDismissedUpdate(true)}
      />
    </>
  );
};
